/**
 * PLT-7846: the "Ask Upright to review this" card in `/chat`. Shared by the chat-only tool that
 * renders it, the route that sends it, and the card itself, so the three cannot disagree on a
 * field's name or length.
 */

/** Cap on each written field. Long enough for a paragraph, short enough for one Slack post. */
export const REVIEW_REQUEST_FIELD_MAX_LENGTH = 2000;

/** Cap on the source link. */
export const REVIEW_REQUEST_SOURCE_MAX_LENGTH = 500;

/** What the user sends: the fields of the card, as they left them. */
export interface ReviewRequestFields {
  question: string;
  problem: string;
  expected: string;
  /** An optional link backing the request up. Empty when the user left it blank. */
  source: string;
}

/** `sent` went to the Upright team; `cancelled` means the user closed the card without sending. */
export type ReviewRequestStatus = 'sent' | 'cancelled';

/**
 * `GET /api/chat/review-requests/availability`: whether the user's organisation may send one. Read
 * from the server rather than the client's plan hooks, so the thumbs-down form's link and the card
 * are offered to exactly the same users.
 */
export interface ReviewRequestAvailabilityResponse {
  available: boolean;
}

/** `GET /api/chat/review-requests/{conversationId}/{messageIndex}`: whether the card was answered. */
export interface ReviewRequestStateResponse {
  status: ReviewRequestStatus | null;
}
